import axios from 'axios'
import moment from 'moment-timezone';
import { serialize } from '../utilities'

export class BtaConvertReservationToCart {
  static init(reservation, options = {}) {
    this.reservation = reservation
    this.onSuccess = options.onSuccess
    this.onError = options.onError
    this.options = options || {}
    this.queue = []
  }

  static addToCart(reservation, options = {}) {
    this.init(reservation, options)

    const {
            onSuccess, reservation: {tz}
          }          = this,
          dateFormat = options.dateFormat || 'MM/DD/YYYY',
          locale     = navigator.language || navigator.userLanguage || 'en-US',
          timeFormat = locale.substr(0, 2) === 'en' ? 'hh:mm A' : 'HH:mm',
          form       = document.querySelector('form[action="/cart/add"]')

    let properties = {}
    if (form) {
      const formData = serialize(form)
      for (let key in formData) {
        const regex = /properties\[(.*)\]/.exec(key)
        if (regex && regex[1]) properties[regex[1]] = formData[key]
      }
    }

    this.reservation.items.forEach((item) => {
      this.queue.push({
        id: item.external_id,
        quantity: item.quantity,
        properties: {
          ...properties,
          Date: moment.tz(item.start, tz).format(`${dateFormat}`),
          Time: moment.tz(item.start, tz).format(`${timeFormat}`),
        }
      })
    })

    this.moveAlong(() => {
      onSuccess && onSuccess(this.queue, reservation)
      window.location = `/${options.redirect === 'checkout' ? 'checkout' : 'cart'}`
    })
  }

  static moveAlong(callback) {
    const self = this
    if (self.queue.length) {
      let request = self.queue.shift();

      axios.post('/cart/add.js', request)
           .then(() => self.moveAlong(callback))
           .catch(errors => self.onError ? self.onError(errors, request) : console.log(errors, request))
    }
    else {
      callback && callback()
    }
  }
}